import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateUserLanguageParams {
  userId: string; // server user id
  language: string;
}

export class UpdateUserLanguageRequest extends Request<IUpdateUserLanguageParams, IResult> {
  constructor(params: IUpdateUserLanguageParams) {
    super('updateUserLanguage', params);
  }
}
